import React, { PropTypes } from 'react'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Loading from 'components/Loading'
import Alert from 'components/Alert'
import FileUploader from 'components/FileUploader/FileUploader'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import SubmitButton from 'components/SubmitButton'
import constants from 'constants'
import PartnerPlanRatingsUploadList from './components/PartnerPlan/PartnerPlanRatingsUploadList'
import { agent } from 'utils/api'
// import moment from 'moment'
import { getConfig } from 'utils/config'

const styles = Object.assign(
  {},
  require('./PartnerPlans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class PartnerPlanRatingsUploadView extends React.Component {
  static propTypes = {
    completeText: PropTypes.string,
    ctaText: PropTypes.string,
    deletePartnerPlanRatings: PropTypes.object.isRequired,
    initPartnerPlanRatings: PropTypes.object.isRequired,
    partnerPlanRatingsUpload: PropTypes.object.isRequired,
    sendNotification: PropTypes.object.isRequired,
    submittingText: PropTypes.string,
  }
  static defaultProps = {
    ctaText: 'Upload Counselling Ratings',
    completeText: 'Uploaded',
    submittingText: 'Uploading',
  }

  constructor() {
    super()

    this.state = {
      submittedFiles: [],
      uploader: null,
      isComplete: false,
      isPosting: false,
    }
  }

  componentWillMount() {
    this.setState({ uploader: this.myUploader() })
  }

  setSubmittedFiles = (submittedFiles) => {
    this.setState({ submittedFiles })
  }

  setFileUploaderResponse = (response) => {
  }

  handleDeleteDocument = (itemId) => {
    this.props.deletePartnerPlanRatings(itemId, getConfig().PLAN_RATINGS, constants.PARTNERPLAN.RATINGSUPLOAD_FOLDER.CP)
  }

  _initForm = () => {
    this.setState({ isPosting: false }, () => {
      this.state.uploader.methods.reset()
      this.setState({ isComplete: true })
      this.setState({ submittedFiles: [] })
      setTimeout(() => {
        this.props.initPartnerPlanRatings(getConfig().PLAN_RATINGS, constants.PARTNERPLAN.RATINGSUPLOAD_FOLDER.CP)
        this.setState({ isComplete: false })
      }, 2000)
    })
  }

  _handleSubmit = () => {
    if (this.state.submittedFiles.length > 0) {
      this.setState({ isPosting: true }, () => {
        this.state.uploader.methods.uploadStoredFiles()
      })
    }
  }

  _handleAllUploadComplete = (id, name, response) => {
    if (response.success) {
      // this._initForm()
    } else {
      this.props.sendNotification(response.error)
    }
  }

  _handleUploadComplete = (id, name, response) => {
    if (response.success || response.error) {
      this.props.sendNotification(response.error)
    }
    this._initForm()
  }

  _handleUploadError = (id, name, response) => {
    this.props.sendNotification((response.error ? response.error : response))
    this._initForm()
  }

  // Moving logic from Uploader ...
  myUploader = () => {
    // const { allowedExtensions, uploadID, maxFileSize } = this.props
    const allowedExtensions = ['csv']
    // const uploadID = '1234'
    const maxFileSize = constants.PARTNERPLAN.MAX_FILESIZE
    const maxFileNumber = 1

    return new FineUploaderTraditional({
      options: {
        debug: true,
        autoUpload: false,
        request: {
          endpoint: agent.FileUploader.uploadplanratings(),
          params: {
            loginname: this.props.currentUser,
            employee_id: this.props.currentUser.EmployeeId,
            library_name: getConfig().PLAN_RATINGS,
            folder_name: constants.PARTNERPLAN.RATINGSUPLOAD_FOLDER.CP,
            overwrite: 'false',
            hierarchy_role: constants.PARTNERPLAN.RATINGSUPLOAD_FOLDER.CP,
          },
          paramsInBody: true,
        },
        cors: {
          expected: true,
          sendCredentials: true,
        },
        // deleteFile: {
        //   enabled: true,
        // },
        validation: {
          acceptFiles: allowedExtensions.map(e => `.${e}`),
          allowedExtensions,
          sizeLimit: maxFileSize,
          itemLimit: maxFileNumber,
        },
        chunking: {
          enabled: false,
          partSize: 5242880, // 5mb
          concurrent: {
            enabled: true,
          },
          success: {
          },
        },
        callbacks: {
          // onSubmit: this.uploaderSubmit,
          // onSubmitted: this.uploaderSubmitted,
          // onComplete: this._handleFormSubmit,
          onComplete: this._handleUploadComplete,
          onError: this._handleUploadError,
          // onStatusChange: this.uploaderStatusChange,
          // onProgress: this.uploaderProgress,
          // onUploadChunk: this.uploadChunk,
          // onUploadChunkSuccess: this.uploadChunkSuccess,
          // onUpload: this.startUpload,
          onAllComplete: this._handleAllUploadComplete,
          // onCancel: this.onCancel,
          // onDelete: this.onDelete,
        },
      },
    })
  }

  canSubmit = () => {
    return (this.state.submittedFiles.length > 0)
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      partnerPlanRatingsUpload,
    } = this.props
    // eslint-disable-next-line dot-notation
    // const form = this.props.forms['PartnerPlanRatingsUpload']
    if (partnerPlanRatingsUpload.isFetching) {
      return (<Loading pageLoading />)
    }
    return (
      <div className={styles.content}>
        <Alert showCloseButton={false} type="info">
          {constants.PARTNERPLAN.RATINGSUPLOAD_INSTRUCTIONS}. <br /><b>{constants.PARTNERPLAN.RATINGSUPLOAD_INSTRUCTIONS_REVIEW}</b>
        </Alert>
        <section className={styles.section}>
          {partnerPlanRatingsUpload.fetched && partnerPlanRatingsUpload.ratingsUploaded &&
          <div>
            <PartnerPlanRatingsUploadList
              header={constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETED}
              partnerPlanRatingsUploadItems={partnerPlanRatingsUpload.ratingsUploaded.filter(ppr => String(ppr.status) === constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETED
                || String(ppr.status) === constants.PARTNERPLAN.RATINGSUPLOAD.ERROR
                || String(ppr.status) === constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETEDWITHERRORS
                || String(ppr.status) === constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETEDWITHWARNINGS
                || String(ppr.status) === constants.PARTNERPLAN.RATINGSUPLOAD.INVALIDUPLOAD)}
            />
            <PartnerPlanRatingsUploadList
              header={`Download ${constants.PARTNERPLAN.RATINGSUPLOAD.TEMPLATE}`}
              partnerPlanRatingsUploadItems={partnerPlanRatingsUpload.ratingsUploaded.filter(ppr => String(ppr.status) === constants.PARTNERPLAN.RATINGSUPLOAD.TEMPLATE)}
            />
          </div>}
          <div>
            <Heading noTopPadding>Upload Counselling partner ratings</Heading>
            <Card>
              <div className={styles.uploadSection}>
                <Alert type="info">
                Ensure filenames only use numbers, letters and underscores.
                </Alert>
                <FileUploader
                  allowedExtensions={['csv']}
                  handleDeleteExistingFile={file => console.log('### delete', file)}
                  handleSelectedFile={() => console.log('### selected ###')} // 1 MB = 1000 * 1000 * 1024 bytes
                  labelWidth={20}
                  maxFileSize={constants.PARTNERPLAN.MAX_FILESIZE}
                  multiple={false}
                  setFileUploaderResponse={this.setFileUploaderResponse}
                  setSubmittedFiles={this.setSubmittedFiles}
                  uploadDescText="CSV only, max 20mb."
                  // disabled={fileUploaderDisabled}
                  uploadTitle="Add files here"
                  uploader={this.state.uploader}
                />
                <div className={styles.footer}>
                  <SubmitButton
                    isLarge
                    complete={this.state.isComplete}
                    completeText={completeText} // Add validation rules
                    disabled={!this.canSubmit()}
                    onClick={() => this._handleSubmit()}
                    submitting={this.state.isPosting}
                    submittingText={submittingText}
                  >
                    {ctaText}
                  </SubmitButton>
                </div>
              </div>
            </Card>
          </div>
        </section>
      </div>
    )
  }
}

export default PartnerPlanRatingsUploadView



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanRatingsUpload.js